<div *ngIf="loading" class="flex justify-center items-center py-12">
	<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
	<span class="ml-2 text-gray-600">Chargement des détails...</span>
</div>

<div *ngIf="!loading && prestation" class="relative p-6 space-y-8">
	<div class="bg-gradient-to-r from-primary-50 to-blue-50 rounded-xl p-6 border border-primary-100">
		<div class="flex items-center justify-between">
			<div class="flex items-center space-x-4">
				<div class="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
					<lucide-icon [img]="FileText" class="w-6 h-6 text-primary-600"></lucide-icon>
				</div>
				<div>
					<h2 class="!text-[18px] font-bold text-gray-900">{{ prestation.type?.label }}</h2>
					<p class="text-sm text-gray-600">{{ prestation.costumId }}</p>
				</div>
			</div>
			<div *ngIf="prestation && prestation.amount > 0" class="text-right">
				<span class="inline-flex px-3 py-1 text-sm font-semibold rounded-full"
					[ngClass]="prestation.category?.code === 'MEDICAL' ? 'bg-green-100 text-green-800' : prestation.category?.code === 'FINANCIAL' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'">
					<!-- {{ getPrestationStatus(prestation).label }} --> Montant total
				</span>
				<div class="text-2xl font-bold text-gray-900 mt-1">{{
					formatAmount(prestation.amount) }}</div>
			</div>
		</div>
	</div>

	<div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
		<div class="lg:col-span-2 space-y-6">
			<div class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="FileText" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Informations générales
				</h3>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div class="space-y-3">
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">ID personnalisé</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.costumId }}</span>
						</div>
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">ID Eyone</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.sourceEyoneInternalId
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2">
							<span class="text-sm font-medium text-gray-600">Type</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.type?.label }}</span>
						</div>
					</div>
					<div class="space-y-3">
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">Catégorie</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.category?.label || '-'
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">Canal</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.channel?.label || '-'
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2">
							<span class="text-sm font-medium text-gray-600">Source</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.source?.label || '-'
								}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- Section Medical Quote Items -->
			<div *ngIf="prestation.medicalQuoteItems && prestation.medicalQuoteItems.length > 0"
				class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="FileText" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Éléments du devis médical
				</h3>
				<div class="space-y-4">
					<div *ngFor="let item of prestation.medicalQuoteItems; trackBy: trackByQuoteItem"
						class="bg-gray-50 rounded-lg p-4 border border-gray-200">
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<div class="space-y-2">
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Nom:</span>
									<span class="text-sm font-semibold text-gray-900">{{ item.name }}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Type:</span>
									<span class="text-sm font-semibold text-gray-900">{{
										(item.quoteItemType && item.quoteItemType.label) || '-'}}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">ID personnalisé:</span>
									<span class="text-sm font-semibold text-gray-900">{{ item.customId }}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">ID Eyone:</span>
									<span class="text-sm font-semibold text-gray-900">{{ item.eyoneInternalId }}</span>
								</div>
							</div>
							<div class="space-y-2">
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Prix unitaire:</span>
									<span class="text-sm font-semibold text-gray-900">{{ formatAmount(item.soldPrice)
										}}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Quantité:</span>
									<span class="text-sm font-semibold text-gray-900">{{ item.quantity }}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Total:</span>
									<span class="text-sm font-bold text-primary-600">{{ formatAmount(item.totalPrice)
										}}</span>
								</div>
							</div>
						</div>

						<!-- Statuts -->
						<div class="mt-4 pt-3 border-t border-gray-200">
							<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Statut:</span>
									<span class="inline-flex px-2 py-1 text-xs font-medium rounded-full"
										[ngClass]="getQuoteItemStatusClass(item.status)">
										{{ item.status.label }}
									</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Paiement:</span>
									<span class="inline-flex px-2 py-1 text-xs font-medium rounded-full"
										[ngClass]="getPaymentStatusClass(item.paymentStatus)">
										{{ item.paymentStatus.label }}
									</span>
								</div>
							</div>

							<!-- Informations supplémentaires -->
							<div
								class="mt-3 pt-3 border-t border-gray-200 grid grid-cols-2 md:grid-cols-4 gap-2 text-xs text-gray-500">
								<div *ngIf="item.hasPharmacyPrestation" class="flex items-center">
									<span class="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
									Pharmacie
								</div>
								<div *ngIf="item.toothPrestationItem" class="flex items-center">
									<span class="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
									Dentaire
								</div>
								<div *ngIf="item.requireCareRequest" class="flex items-center">
									<span class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
									Demande de soins
								</div>
								<div *ngIf="item.new" class="flex items-center">
									<span class="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
									Nouveau
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- Section Documents -->
			<div class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="FileText" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					{{ getDocumentsSectionTitle() }}
				</h3>

				<!-- Chargement des documents -->
				<div *ngIf="loadingDocuments" class="flex justify-center items-center py-8">
					<div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
					<span class="ml-2 text-sm text-gray-600">Chargement des documents...</span>
				</div>

				<!-- Accordéons pour les prestations médicales -->
				<div *ngIf="!loadingDocuments && isPrestationMedical" class="space-y-3">
					@for (section of visibleAccordionSections; track section.key) {
					@let sectionDocuments = getSectionDocuments(section.key);
					@let isOpen = isAccordionOpen(section.key);

					<div class="border border-gray-200 rounded-lg overflow-hidden">
						<!-- En-tête de l'accordéon avec barre rouge -->
						<button class="w-full flex items-center gap-4 p-4 hover:bg-gray-50 transition-colors"
							(click)="toggleAccordion(section.key)">
							<!-- Barre rouge verticale -->
							<div class="w-1 h-6 bg-primary rounded"></div>

							<!-- Titre de la section -->
							<h4 class="flex-1 text-left text-xs font-semibold text-gray-900 uppercase">
								{{ section.label }}
							</h4>

							<!-- Badge avec le nombre de documents -->
							@if (getSectionDocumentsCount(section.key) !== null) {
							<span class="text-xs font-medium text-gray-600 bg-gray-100 px-2 py-1 rounded">
								{{ getSectionDocumentsCount(section.key) }}
							</span>
							}

							<!-- Icône de chevron -->
							<svg class="w-4 h-4 text-gray-500 transition-transform" [class.rotate-180]="isOpen"
								fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
									d="M19 9l-7 7-7-7" />
							</svg>
						</button>

						<!-- Contenu de l'accordéon -->
						<div class="overflow-hidden transition-all duration-300" [class.max-h-0]="!isOpen"
							[class.max-h-[2000px]]="isOpen">
							<div class="p-4 border-t border-gray-200">
								<!-- Indicateur de chargement -->
								@if (loadingSections[section.key]) {
								<div class="flex justify-center items-center py-8">
									<div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
									<span class="ml-2 text-sm text-gray-600">Chargement...</span>
								</div>
								} @else if (!isMockSiSection(section.key) && section.key !== 'histoire_maladie' && sectionDocuments.length === 0) {
								<div class="text-center py-4 text-gray-500 text-xs">
									Aucun document dans cette section
								</div>
								} @else {
								<!-- Tableau selon le type de section -->
								@if (section.key === 'actes_medicaux') {
								<div class="space-y-4">
									<div class="overflow-x-auto">
										<table class="w-full text-xs">
											<thead>
												<tr class="bg-gray-100 border-b border-gray-200">
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Libellé
													</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Date de
														l'acte</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Effectué
														par</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Statut
													</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Détails
													</th>
												</tr>
											</thead>
											<tbody>
												@for (item of siMockData.actes_medicaux.items; track $index) {
												<tr class="border-b border-gray-100">
													<td class="py-2 px-3 text-gray-900">{{ item.libelle }}</td>
													<td class="py-2 px-3 text-gray-900">{{ item.dateActe }}</td>
													<td class="py-2 px-3 text-gray-900">{{ item.effectuePar }}</td>
													<td class="py-2 px-3 text-gray-900">{{ item.statut }}</td>
													<td class="py-2 px-3">
														<button type="button"
															class="btn btn-outline min-h-0 h-7 w-7 px-0"
															[matTooltip]="'Voir les détails'"
															(click)="onMedicalActDetails(item)"
															aria-label="Voir les détails de l'acte">
															<lucide-icon [img]="Eye" size="14"></lucide-icon>
														</button>
													</td>
												</tr>
												}
												@if (siMockData.actes_medicaux.items.length === 0) {
												<tr>
													<td colspan="5" class="py-6 px-3 text-center text-gray-500">
														Aucune donnée disponible.
													</td>
												</tr>
												}
											</tbody>
										</table>
									</div>
									<div class="text-xs text-gray-600">
										Affichage de l'élément 1 à 0 sur 0 éléments
									</div>
								</div>
								}

								@if (section.key === 'diagnostic') {
								<div class="space-y-3">
									<div>
										<label class="text-xs font-medium text-gray-700">Maladie/Etat de santé</label>
										<div
											class="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900">
											{{ getDiagnosticOptionLabel() }}
										</div>
									</div>
									<div>
										<label class="text-xs font-medium text-gray-700">Commentaire</label>
										<div class="mt-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 prose prose-sm max-w-none"
											[innerHTML]="siMockData.diagnostic.commentaireHtml || '-'">
										</div>
									</div>
								</div>
								}

								@if (section.key === 'motifs') {
								<div class="space-y-3">
									@if (prestation && prestation.motifs && prestation.motifs.length > 0) {
									@for (motif of prestation.motifs; track motif.id) {
									<div
										class="flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900">
										<span class="font-medium">{{ motif.name }}</span>
									</div>
									}
									} @else {
									<div class="text-center py-4 text-gray-500 text-xs">
										Aucun motif renseigné
									</div>
									}
								</div>
								}

								@if (section.key === 'formulaires_documents') {
								<div class="space-y-4 rounded-xl border border-gray-200 bg-white p-4">
									<div class="overflow-x-auto overflow-y-visible rounded-lg border border-gray-100">
										<table class="w-full text-xs">
											<thead>
												<tr class="bg-gray-50 border-b border-gray-200">
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Nom</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">
														Extension</th>
													<th class="text-left py-2 px-3 font-semibold text-gray-900">Actions
													</th>
												</tr>
											</thead>
											<tbody>
												@for (form of siMockData.formulaires_documents.forms; track form.nom) {
												<tr class="border-b border-gray-100">
													<td class="py-2 px-3 text-gray-900">{{ form.nom }}</td>
													<td class="py-2 px-3 text-gray-600 font-medium">{{ form.extension }}
													</td>
													<td class="py-2 px-3">
														<div class="flex items-center gap-2">
															<button type="button" [matTooltip]="'Visualiser'"
																class="btn btn-outline min-h-0 h-7 w-7 px-0"
																(click)="viewMockDocument(form)">
																<lucide-icon [img]="Eye" size="14"></lucide-icon>
															</button>
															<button type="button" [matTooltip]="'Télécharger'"
																class="btn btn-primary min-h-0 h-7 w-7 px-0"
																(click)="downloadMockDocument(form)">
																<lucide-icon [img]="Download" size="14"></lucide-icon>
															</button>
														</div>
													</td>
												</tr>
												}
												@for (doc of siMockData.formulaires_documents.documents; track doc.nom)
												{
												<tr class="border-b border-gray-100">
													<td class="py-2 px-3 text-gray-900">{{ doc.nom }}</td>
													<td class="py-2 px-3 text-gray-600 font-medium">{{ doc.extension }}
													</td>
													<td class="py-2 px-3">
														<div class="flex items-center gap-2">
															<button type="button" [matTooltip]="'Visualiser'"
																class="btn btn-outline min-h-0 h-7 w-7 px-0 "
																(click)="viewMockDocument(doc)">
																<lucide-icon [img]="Eye" size="14"></lucide-icon>
															</button>
															<button type="button" [matTooltip]="'Télécharger'"
																class="btn btn-primary  min-h-0 h-7 w-7 px-0"
																(click)="downloadMockDocument(doc)">
																<lucide-icon [img]="Download" size="14"></lucide-icon>
															</button>
														</div>
													</td>
												</tr>
												}
											</tbody>
										</table>
									</div>
									<div
										class="flex flex-col gap-1 text-xs text-gray-600 sm:flex-row sm:items-center sm:justify-between">
										<span>Affichage de l'élément 1 à 0 sur 0 éléments</span>
										<span>Afficher 10 éléments</span>
									</div>
								</div>
								}

								@if (section.key === 'histoire_maladie') {
								<div class="space-y-3">
									<div class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 prose prose-sm max-w-none"
										[innerHTML]="prestation?.story || '-'">
									</div>
								</div>
								}

								@if (section.key === 'conclusion') {
								<div class="space-y-3">
									<div class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 prose prose-sm max-w-none"
										[innerHTML]="siMockData.conclusion.contenuHtml || '-'">
									</div>
								</div>
								}

								@if (section.key === 'ordonnances') {
								<div class="overflow-x-auto">
									<table class="w-full text-xs">
										<thead>
											<tr class="bg-gray-100 border-b border-gray-200">
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Référence
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Prescripteur
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Prescris le
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Transmis au
													passport</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Type
													d'ordonnance</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Documents
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Actions</th>
											</tr>
										</thead>
										<tbody>
											@for (item of sectionDocuments; track item._id || item.id) {
											<tr class="hover:bg-gray-50 border-b border-gray-100">
												<td class="py-2 px-3 text-gray-900">{{ item.eyoneInternalId ||
													item.reference }}</td>
												<td class="py-2 px-3 text-gray-900">{{
													item.prescriptor?.doctorCompleteName || item.prescripteur || '-' }}
												</td>
												<td class="py-2 px-3 text-gray-900">{{
													formatPrescriptionDate(item.creationDate || item.prescritLe) }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.teletransmitted !==
													undefined ? (item.teletransmitted ? 'Oui' : 'Non') :
													(item.transmisAuPassport ? 'Oui' : 'Non') }}</td>
												<td class="py-2 px-3 text-red-600">{{ item.status?.label ||
													item.typeOrdonnance || '-' }}</td>
												<td class="py-2 px-3">
													@if (item.documents && item.documents.length > 0) {
													<div class="flex flex-wrap gap-1">
														@for (doc of item.documents; track doc._id || doc.filename) {
														<span
															class="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">
															<lucide-icon [img]="FileText" [size]="12"></lucide-icon>
															{{ doc.filename }}
														</span>
														}
													</div>
													} @else {
													<span class="text-gray-400 text-xs">Aucun document</span>
													}
												</td>
												<td class="py-2 px-3">
													@if (item.documents && item.documents.length > 0) {
													<div class="flex gap-2">
														@for (doc of item.documents; track doc._id || doc.filename) {
														<button (click)="viewDocument(doc)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Visualiser {{ doc.filename }}">
															<lucide-icon [img]="Eye" [size]="16"></lucide-icon>
														</button>
														<button (click)="downloadDocument(doc)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Télécharger {{ doc.filename }}">
															<lucide-icon [img]="Download" [size]="16"></lucide-icon>
														</button>
														}
													</div>
													} @else {
													<span class="text-gray-400 text-xs">-</span>
													}
												</td>
											</tr>
											}
										</tbody>
									</table>
								</div>
								}

								@if (section.key === 'examens_demandes') {
								<div class="overflow-x-auto">
									<table class="w-full text-xs">
										<thead>
											<tr class="bg-gray-100 border-b border-gray-200">
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Référence
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Type
													d'examen</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Demandeur
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Demandé le
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Transmis au
													passport</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Statut</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Documents
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Actions</th>
											</tr>
										</thead>
										<tbody>
											@for (item of sectionDocuments; track item._id || item.id) {
											<tr class="hover:bg-gray-50 border-b border-gray-100">
												<td class="py-2 px-3 text-gray-900">{{ item.eyoneInternalId ||
													item.reference }}</td>
												<td class="py-2 px-3 text-gray-900">
													<div>{{ item.actPrescriptionType?.label || item.typeExamen || '-' }}
													</div>
													@if (item.items && item.items.length > 0) {
													<div class="text-gray-500 text-xs mt-1">
														{{ item.items.length }} examen(s)
													</div>
													}
												</td>
												<td class="py-2 px-3 text-gray-900">{{
													item.prescriptor?.doctorCompleteName || item.demandeur || '-' }}
												</td>
												<td class="py-2 px-3 text-gray-900">{{ item.creationDate ||
													item.demandeLe || '-' }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.teletransmitted !==
													undefined ? (item.teletransmitted ? 'Oui' : 'Non') :
													(item.transmisAuPassport ? 'Oui' : 'Non') }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.pstatus?.label ||
													item.statut || '-' }}</td>
												<td class="py-2 px-3">
													@if (item.documents && item.documents.length > 0) {
													<div class="flex flex-wrap gap-1">
														@for (doc of item.documents; track doc._id || doc.filename) {
														<span
															class="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">
															<lucide-icon [img]="FileText" [size]="12"></lucide-icon>
															{{ doc.filename }}
														</span>
														}
													</div>
													} @else {
													<span class="text-gray-400 text-xs">Aucun document</span>
													}
												</td>
												<td class="py-2 px-3">
													@if (item.documents && item.documents.length > 0) {
													<div class="flex gap-2">
														@for (doc of item.documents; track doc._id || doc.filename) {
														<button (click)="viewDocument(doc)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Visualiser {{ doc.filename }}">
															<lucide-icon [img]="Eye" [size]="16"></lucide-icon>
														</button>
														<button (click)="downloadDocument(doc)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Télécharger {{ doc.filename }}">
															<lucide-icon [img]="Download" [size]="16"></lucide-icon>
														</button>
														}
													</div>
													} @else {
													<span class="text-gray-400 text-xs">-</span>
													}
												</td>
											</tr>
											}
										</tbody>
									</table>
								</div>
								}

								<!-- @if (section.key === 'documents_formulaires') {
								<div class="overflow-x-auto">
									<table class="w-full text-xs">
										<thead>
											<tr class="bg-gray-100 border-b border-gray-200">
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Référence
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Type de
													document</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Émetteur
												</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Émis le</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Transmis au
													passport</th>
												<th class="text-left py-2 px-3 font-semibold text-gray-900">Actions</th>
											</tr>
										</thead>
										<tbody>
											@for (item of sectionDocuments; track item.id) {
											<tr class="hover:bg-gray-50 border-b border-gray-100">
												<td class="py-2 px-3 text-gray-900">{{ item.reference }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.typeDocument }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.emetteur }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.emisLe }}</td>
												<td class="py-2 px-3 text-gray-900">{{ item.transmisAuPassport ? 'Oui' :
													'Non' }}</td>
												<td class="py-2 px-3">
													<div class="flex gap-2">
														<button (click)="viewMockDocument(item)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Visualiser">
															<lucide-icon [img]="Eye" [size]="16"></lucide-icon>
														</button>
														<button (click)="downloadMockDocument(item)"
															class="text-primary-600 hover:text-primary-800 transition-colors"
															title="Télécharger">
															<lucide-icon [img]="Download" [size]="16"></lucide-icon>
														</button>
													</div>
												</td>
											</tr>
											}
										</tbody>
									</table>
								</div>
								} -->
								}
							</div>
						</div>
					</div>
					}
				</div>

				<!-- Ancien affichage en tableau pour les prestations non médicales -->
				<div *ngIf="!loadingDocuments && !isPrestationMedical">
					<!-- Liste des documents -->
					<div *ngIf="documents.length > 0" class="space-y-2">
						<div *ngFor="let document of documents; trackBy: trackByDocument"
							class="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
							<div class="flex items-center">
								<lucide-icon [img]="FileText" class="w-4 h-4 text-gray-400 mr-2"></lucide-icon>
								<span class="text-sm font-medium text-gray-900">{{ document.filename || 'Document'
									}}</span>
							</div>
							<div class="flex gap-2">
								<button (click)="viewDocument(document)"
									class="text-primary-600 hover:text-primary-800 transition-colors"
									title="Visualiser">
									<lucide-icon [img]="Eye" [size]="20"></lucide-icon>
								</button>
								<button (click)="downloadDocument(document)"
									class="text-primary-600 hover:text-primary-800 transition-colors"
									title="Télécharger">
									<lucide-icon [img]="Download" [size]="20"></lucide-icon>
								</button>
							</div>
						</div>
					</div>

					<!-- Aucun document -->
					<div *ngIf="documents.length === 0" class="text-center py-8 text-gray-500 text-sm">
						<lucide-icon [img]="FileText" class="w-12 h-12 mx-auto mb-2 text-gray-300"></lucide-icon>
						<p>Aucun document disponible</p>
					</div>
				</div>
			</div>


			<div class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="Calendar" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Planning
				</h3>
				<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
					<div class="text-center p-4 bg-blue-50 rounded-lg">
						<lucide-icon [img]="Calendar" class="w-6 h-6 text-blue-600 mx-auto mb-2"></lucide-icon>
						<div class="text-sm font-medium text-gray-600">Début</div>
						<div class="text-sm font-semibold text-gray-900">{{ formatDateTime(prestation.startDate) }}
						</div>
					</div>
					<div class="text-center p-4 bg-green-50 rounded-lg">
						<lucide-icon [img]="Calendar" class="w-6 h-6 text-green-600 mx-auto mb-2"></lucide-icon>
						<div class="text-sm font-medium text-gray-600">Fin</div>
						<div class="text-sm font-semibold text-gray-900">{{ formatDateTime(prestation.endDate) }}</div>
					</div>
					<div class="text-center p-4 bg-purple-50 rounded-lg">
						<lucide-icon [img]="Clock" class="w-6 h-6 text-purple-600 mx-auto mb-2"></lucide-icon>
						<div class="text-sm font-medium text-gray-600">Créé le</div>
						<div class="text-sm font-semibold text-gray-900">{{ formatDateTime(prestation.createdAt) }}
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="prestation.roomStays && prestation.roomStays.length > 0"
				class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="MapPin" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Séjours en chambre
				</h3>
				<div class="space-y-4">
					<div *ngFor="let stay of prestation.roomStays; trackBy: trackByStay"
						class="bg-gray-50 rounded-lg p-4 border border-gray-200">
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<div class="space-y-2">
								<div class="flex items-center">
									<span class="text-sm font-medium text-gray-600 w-20">Chambre:</span>
									<span class="text-sm font-semibold text-gray-900">{{ stay.room.name || 'Non
										spécifiée' }}</span>
								</div>
								<div class="flex items-center">
									<span class="text-sm font-medium text-gray-600 w-20">Lit:</span>
									<span class="text-sm font-semibold text-gray-900">{{ stay.bed.name || 'Non spécifié'
										}}</span>
								</div>
								<div class="flex items-center">
									<span class="text-sm font-medium text-gray-600 w-20">Catégorie:</span>
									<span class="text-sm font-semibold text-gray-900">{{ stay.room.category.name || 'Non
										spécifiée'
										}}</span>
								</div>
							</div>
							<div class="space-y-2">
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Prix unitaire:</span>
									<span class="text-sm font-semibold text-gray-900">{{ formatAmount(stay.soldPrice)
										}}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Quantité:</span>
									<span class="text-sm font-semibold text-gray-900">{{ stay.quantity }}</span>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-sm font-medium text-gray-600">Total:</span>
									<span class="text-sm font-semibold text-primary-600">{{
										formatAmount(stay.totalPrice) }}</span>
								</div>
							</div>
						</div>
						<div class="mt-3 pt-3 border-t border-gray-200 text-xs text-gray-500 text-center">
							Du {{ formatDate(stay.startDate) }} au {{ formatDate(stay.endDate) }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="space-y-6">
			<div class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="MapPin" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Établissement
				</h3>
				<div class="space-y-3">
					<div class="flex items-center p-3 bg-gray-50 rounded-lg">
						<lucide-icon [img]="MapPin" class="w-4 h-4 text-gray-400 mr-3"></lucide-icon>
						<div>
							<div class="text-sm font-medium text-gray-900">{{ prestation.structure.name || 'Non
								spécifié' }}</div>
							<div class="text-xs text-gray-500">Structure médicale</div>
						</div>
					</div>
					<div *ngIf="prestation.doctor?.completeName" class="flex items-center p-3 bg-blue-50 rounded-lg">
						<lucide-icon [img]="User" class="w-4 h-4 text-blue-500 mr-3"></lucide-icon>
						<div>
							<div class="text-sm font-medium text-gray-900">Dr. {{ prestation.doctor?.completeName }}
							</div>
							<div class="text-xs text-gray-500">Médecin traitant</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Section Prescription -->
			<div *ngIf="prestation.prescription" class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="FileText" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Prescription
				</h3>
				<div class="grid grid-cols-1 md:grid-cols-1 gap-6">
					<div class="space-y-3">
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">Identifiant</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.prescription.identifier
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">ID Eyone</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.prescription.eyoneInternalId
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">ID personnalisé</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.prescription.customId
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2">
							<span class="text-sm font-medium text-gray-600">Créé par</span>
							<span class="text-sm font-semibold text-gray-900">{{ prestation.prescription.createdBy
								}}</span>
						</div>
					</div>
					<div class="space-y-3">
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">Date de création</span>
							<span class="text-sm font-semibold text-gray-900">{{
								formatDate(prestation.prescription.creationDate)
								}}</span>
						</div>
						<div class="flex justify-between items-center py-2 border-b border-gray-100">
							<span class="text-sm font-medium text-gray-600">Statut</span>
							<span class="text-sm font-semibold"
								[ngClass]="prestation.prescription.disable ? 'text-red-600' : 'text-green-600'">
								{{ prestation.prescription.disable ? 'Désactivée' : 'Active' }}
							</span>
						</div>
						<div class="flex justify-between items-center py-2">
							<span class="text-sm font-medium text-gray-600">Médicaments</span>
							<span class="text-sm font-semibold text-gray-900">{{
								prestation.prescription.medications.length || 0 }}
								produit(s)</span>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="prestation.amount > 0" class="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
				<h3 class="!text-[18px] font-semibold text-gray-900 mb-4 flex items-center">
					<lucide-icon [img]="DollarSign" class="w-5 h-5 text-gray-500 mr-2"></lucide-icon>
					Détails financiers
				</h3>
				<div class="space-y-3">
					<div class="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
						<span class="text-sm font-medium text-gray-600">Montant total</span>
						<span class="text-sm font-bold text-gray-900">{{ formatAmount(prestation.amount) }}</span>
					</div>
					<div *ngIf="prestation.careAmount > 0"
						class="flex justify-between items-center p-3 bg-green-50 rounded-lg">
						<span class="text-sm font-medium text-gray-600">Prise en charge</span>
						<span class="text-sm font-bold text-green-600">{{ formatAmount(prestation.careAmount) }}</span>
					</div>
					<div *ngIf="prestation.patientAmount > 0"
						class="flex justify-between items-center p-3 bg-red-50 rounded-lg">
						<span class="text-sm font-medium text-gray-600">Reste à payer</span>
						<span class="text-sm font-bold text-red-600">{{ formatAmount(prestation.patientAmount) }}</span>
					</div>
					<div *ngIf="prestation.carePercentage > 0"
						class="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
						<span class="text-sm font-medium text-gray-600">% remboursé</span>
						<span class="text-sm font-bold text-blue-600">{{ prestation.carePercentage }}%</span>
					</div>
				</div>
			</div>


		</div>
	</div>
</div>

<mat-menu #medicalActActionsMenu="matMenu" xPosition="before" yPosition="below">
	<ng-template matMenuContent let-item="item" let-index="index">
		<button mat-menu-item type="button" (click)="onMedicalActDetails(item)">
			Détails
		</button>
		<button mat-menu-item type="button" (click)="onMedicalActChangeStatus(index)">
			Changer le statut
		</button>
		<button mat-menu-item type="button" (click)="onMedicalActEdit(index)">
			Modifier
		</button>
		<button mat-menu-item type="button" class="text-red-600" (click)="onMedicalActDelete(index)">
			Supprimer
		</button>
	</ng-template>
</mat-menu>

<div *ngIf="isMedicalActDetailsPanelOpen" class="create-act-panel-backdrop" (click)="closeMedicalActDetailsPanel()">
</div>
<aside *ngIf="isMedicalActDetailsPanelOpen && selectedMedicalAct"
	class="create-act-panel bg-white border-l border-gray-200 shadow-xl">
	<div class="flex items-center justify-between p-4 border-b border-gray-200">
		<h4 class="text-base font-semibold text-gray-900">Détails de l'acte médical</h4>
		<button type="button" class="btn btn-xs btn-ghost" (click)="closeMedicalActDetailsPanel()">
			<lucide-icon [img]="X" [size]="16"></lucide-icon>
		</button>
	</div>

	<div class="p-4 space-y-4 text-sm">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div>
				<p class="text-gray-500">Libellé</p>
				<p class="font-medium text-gray-900">{{ selectedMedicalAct.libelle }}</p>
			</div>
			<div>
				<p class="text-gray-500">Statut</p>
				<p class="font-medium text-gray-900">{{ selectedMedicalAct.statut }}</p>
			</div>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div>
				<p class="text-gray-500">Date de l'acte</p>
				<p class="font-medium text-gray-900">{{ selectedMedicalAct.dateActe }}</p>
			</div>
			<div>
				<p class="text-gray-500">Heure</p>
				<p class="font-medium text-gray-900">{{ selectedMedicalAct.actTime || '-' }}</p>
			</div>
		</div>

		<div>
			<p class="text-gray-500">Effectué par</p>
			<p class="font-medium text-gray-900">{{ selectedMedicalAct.effectuePar }}</p>
		</div>

		<div>
			<p class="text-gray-500">Commentaire pré acte</p>
			<p class="font-medium text-gray-900">{{ selectedMedicalAct.preComment || '-' }}</p>
		</div>

		<div>
			<p class="text-gray-500">Commentaire post acte</p>
			<p class="font-medium text-gray-900">{{ selectedMedicalAct.postComment || '-' }}</p>
		</div>
	</div>

	<div class="p-4 border-t border-gray-200 flex justify-center">
		<button type="button" class="btn btn-warning px-6" (click)="closeMedicalActDetailsPanel()">Fermer</button>
	</div>
</aside>

<div *ngIf="isCreateActPanelOpen" class="create-act-panel-backdrop" (click)="closeCreateMedicalActPanel()"></div>
<aside *ngIf="isCreateActPanelOpen" class="create-act-panel bg-white border-l border-gray-200 shadow-xl">
	<div class="flex items-center justify-between p-4 border-b border-gray-200">
		<h4 class="text-base font-semibold text-gray-900">{{`Création de l'acte médical`}}</h4>
		<button type="button" class="btn btn-xs btn-ghost" (click)="closeCreateMedicalActPanel()">
			<lucide-icon [img]="X" [size]="16"></lucide-icon>
		</button>
	</div>

	<div class="p-4 space-y-4">
		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div>
				<label class="text-sm text-gray-700">Acte *</label>
				<select class="select select-bordered w-full mt-1" [(ngModel)]="createActForm.actCode">
					<option value="">Veuillez sélectionner ou rechercher</option>
					@for (option of medicalActOptions; track option.code) {
					<option [value]="option.code">{{ option.label }}</option>
					}
				</select>
				@if (createActSubmitted && !createActForm.actCode) {
				<p class="text-xs text-red-600 mt-1">Ce champs est requis</p>
				}
			</div>

			<div>
				<label class="text-sm text-gray-700">Médecin praticien *</label>
				<select class="select select-bordered w-full mt-1" [(ngModel)]="createActForm.practitioner">
					<option value="">Veuillez sélectionner un élément</option>
					@for (practitioner of practitionerOptions; track practitioner.id) {
					<option [value]="practitioner.id">{{ practitioner.label }}</option>
					}
				</select>
				@if (createActSubmitted && !createActForm.practitioner) {
				<p class="text-xs text-red-600 mt-1">Ce champs est requis</p>
				}
			</div>
		</div>

		<div>
			<label class="text-sm text-gray-700">Statut *</label>
			<select class="select select-bordered w-full mt-1" [(ngModel)]="createActForm.status">
				<option value="Effectue(e)">Effectué(e)</option>
				<option value="Planifie">Planifié</option>
				<option value="Annule">Annulé</option>
			</select>
			@if (createActSubmitted && !createActForm.status) {
			<p class="text-xs text-red-600 mt-1">Ce champs est requis</p>
			}
		</div>
		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div>
				<label class="text-sm text-gray-700">Commentaire Pré Acte</label>
				<textarea class="textarea textarea-sm bg-white w-full mt-1 h-24"
					[(ngModel)]="createActForm.preComment"></textarea>
			</div>
			<div>
				<label class="text-sm text-gray-700">Commentaire Post Acte</label>
				<textarea class="textarea textarea-bordered bg-white  w-full mt-1 h-24"
					[(ngModel)]="createActForm.postComment"></textarea>
			</div>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div>
				<label class="text-sm text-gray-700">{{`Date de l'acte`}} *</label>
				<input type="date" class="input input-bordered w-full mt-1" [(ngModel)]="createActForm.actDate" />
			</div>
			<div>
				<label class="text-sm text-gray-700">Heure</label>
				<input type="time" class="input input-bordered w-full mt-1" [(ngModel)]="createActForm.actTime" />
			</div>
		</div>
	</div>

	<div class="p-4 border-t border-gray-200 flex justify-center gap-3">
		<button type="button" class="btn btn-warning px-6" (click)="closeCreateMedicalActPanel()">Fermer</button>
		<button type="button" class="btn btn-primary px-6" (click)="saveCreateMedicalAct()">Enregistrer</button>
	</div>
</aside>

<div *ngIf="isCreateDocumentPanelOpen" class="create-act-panel-backdrop" (click)="closeCreateDocumentPanel()"></div>
<aside *ngIf="isCreateDocumentPanelOpen" class="create-act-panel bg-white border-l border-gray-200 shadow-xl">
	<div class="flex items-center justify-between p-4 border-b border-gray-200">
		<h4 class="text-base font-semibold text-gray-900">{{`Ajout d'un document au dossier du patient`}}</h4>
		<button type="button" class="btn btn-xs btn-ghost" (click)="closeCreateDocumentPanel()">
			<lucide-icon [img]="X" [size]="16"></lucide-icon>
		</button>
	</div>

	<div class="p-4 space-y-5">
		<div>
			<label class="text-sm text-gray-700">Type de document *</label>
			<select class="select select-bordered w-full mt-1" [(ngModel)]="createDocumentForm.documentType">
				<option value="">Veuillez sélectionner un élément</option>
				@for (type of documentTypeOptions; track type.value) {
				<option [value]="type.value">{{ type.label }}</option>
				}
			</select>
			@if (createDocumentSubmitted && !createDocumentForm.documentType) {
			<p class="text-xs text-red-600 mt-1">Ce champs est requis</p>
			}
		</div>

		<div>
			<label class="text-sm text-gray-700">Fichier *</label>
			<label
				class="mt-2 flex min-h-44 cursor-pointer items-center justify-center rounded-lg border-2 border-dashed border-gray-300 p-6 text-center hover:border-primary">
				<input type="file" class="hidden" (change)="onCreateDocumentFileSelected($event)" />
				<span class="text-2xl leading-10 text-gray-500">
					{{ selectedDocumentFile ? selectedDocumentFile.name : 'cliquez ou glissez pour ajouter un fichier'
					}}
				</span>
			</label>
			@if (createDocumentSubmitted && !selectedDocumentFile) {
			<p class="text-xs text-red-600 mt-1">Veuillez sélectionner un fichier</p>
			}
		</div>
	</div>

	<div class="p-4 border-t border-gray-200 flex justify-center gap-3">
		<button type="button" class="btn btn-warning px-6" (click)="closeCreateDocumentPanel()">Fermer</button>
		<button type="button" class="btn btn-primary px-6" (click)="saveCreateDocument()">Enregistrer</button>
	</div>
</aside>

<div class="flex justify-end p-6 border-t border-gray-200 bg-gray-50">
	<button (click)="closeModal()"
		class="px-6 py-2 btn btn-primary text-white rounded-lg hover:bg-primary-700 transition-colors font-medium">
		<lucide-icon [img]="X" [size]="16"></lucide-icon>
		Fermer
	</button>
</div>